export const HubActions = {
	RECEIVE_NOTIFICATION: 'ReceiveNotification',
	MARK_AS_READ: 'MarkAsRead',
};
